import _ from "lodash";

export const generateEmaiSendlHTML = (event) => {
  const speakersHTML = event?.speakerSettings?.length
    ? event.speakerSettings
        ?.map(
          (speaker) => `
      <div style="display: grid; grid-template-columns: repeat(2, 1fr); gap: 10px; padding: 10px;">
        <div style="font-family: Poppins;">
          <p><strong>Speaker Name:</strong> ${speaker.speakerName || "N/A"}</p>
          <p><strong>Video metting link</strong><input style="border-radius: 5px;" /></p>
        </div>
      </div>
    `,
        )
        .join("")
    : "";

  return `
    <div style="font-family: Arial, sans-serif; line-height: 1.5; color: #333;">
      <table width="100%" style="margin: 0 auto; border-collapse: collapse;">
  
        <!-- Header with Two Images -->
        <tr>
          <td style="padding: 10px;">
            <table width="100%">
              <tr>
                <td style="text-align: left;">
                  <img src=https://justact.s3.ap-south-1.amazonaws.com/Justact/1740660799066-ffa8d6e8-80b2-4bd4-a917-e3f6726cfe17/MulticallLogo.png alt="Left Image" width="174" height="60">
                </td>
                <td style="text-align: right;">
                  <img src=https://justact.s3.ap-south-1.amazonaws.com/Justact/1740660895889-69aaf6ce-c72d-4f41-a143-980ec5b935be/Asset%203%404x-8.png alt="Right Image" width="174" height="60">
                </td>
              </tr>
            </table>
          </td>
        </tr>
        
        <!-- Header -->
        <tr>
          <td style="padding: 10px; font-family:Poppins; text-align: center; background: #0073b1; color: #fff;">
            <h2>Event Confirmation</h2>
          </td>
        </tr>
  
        <!-- Event Title -->
        <tr>
          <td style="padding: 10px; font-size: 16px; font-family: Poppins;">
            <strong>${event.eventTitle ? event?.eventTitle : "-"}</strong> on ${
    event.eventDate ? event.eventDate : "-"
  } at ${event?.eventTime ? event?.eventTime : "-"}
          </td>
        </tr>
  
        <!-- Greeting Message -->
        <tr>
          <td style="padding: 10px; font-family: Poppins;">
            <p>Dear ${event?.coordinatorInfo?.coordinatorName},</p>
            <p>Thank you for choosing MultiCall. Please find the confirmation for the ${
              event.eventTemplate
            } below:</p>
          </td>
        </tr>
  
       <!-- Schedule & Coordinator -->
             <tr>
               <td>
                 <table width="100%" style="background: #4CAF50; color: #fff; padding: 6px;">
                 <tr>
                   <td style="background: #4CAF50; color: white; font-family: Poppins; text-align: start; font-size: 16px; width: 50%;">
                     <strong>Schedule</strong>
                   </td>
                   <td style="background: #4CAF50; color: white; font-family: Poppins; text-align: start; font-size: 16px; width: 50%;">
                     <strong>Coordinator</strong>
                   </td>
                 </tr>
                 </table>
                 <table width="100%" style="border: 1px solid #ddd; padding: 10px;">
                   <tr style="font-family: Poppins;">
                     <td style="width: 300px; padding: 10px;">
                       <p><strong>Event No:</strong> ${event.eventId}</p>
                       <p><strong>Company Name:</strong> ${event.orgName}</p>
                       <p><strong>Date:</strong> ${event.eventDate} at ${
    event.eventTime
  } for ${event.eventDuration}</p>
                       <p><strong>Type:</strong> ${event.eventTemplate}</p>
                     </td>
                     <td style="width: 300px; padding: 10px;">
                       <p><strong>Name:</strong> ${
                         event?.coordinatorInfo?.coordinatorName
                           ? event?.coordinatorInfo?.coordinatorName
                           : "-"
                       }</p>
                       <p><strong>Phone:</strong> ${
                         event?.coordinatorInfo?.coordinatorphone
                           ? event?.coordinatorInfo?.coordinatorphone
                           : "-"
                       }</p>
                       <p><strong>Email ID:</strong> ${
                         event?.coordinatorInfo?.coordinatorEmail
                           ? event?.coordinatorInfo?.coordinatorEmail
                           : "-"
                       }</p>
                       <p><strong>Location:</strong> ${
                         event?.coordinatorInfo?.coordinatorLocation
                           ? event?.coordinatorInfo?.coordinatorLocation
                           : "-"
                       }</p>
                     </td>
                   </tr>
                 </table>
               </td>
             </tr>
       
             <!-- Important Links -->
             <tr>
               <td>
                 <table width="100%" style="background: #4CAF50; color: #fff; padding: 6px; text-align: center;">
                   <tr>
                     <td style="background: #4CAF50; color: white; font-family: Poppins; text-align: center; font-size: 16px; width: 50%;">
                       <strong>Important Links</strong>
                     </td>
                   </tr>
                 </table>
                 <table width="100%" style="border:1px; solid #ddd; padding: 10px;">
                   <tr>
                     <td style="font-family: Poppins; width: 300px; padding: 10px;">
                     ${
                       event?.advanceOptions?.micrositePrefix
                         ? `<p style="display: flex; flex-wrap: wrap;"><strong>Microsite Link:</strong> <a class="ellipsis-link" href="${event.eventUrl}" target="_blank" 
       rel="noopener noreferrer">${event?.advanceOptions?.micrositePrefix}</a></p>`
                         : ""
                     }
                     </td>
                     <td style="font-family: Poppins; width: 300px; padding: 10px;">
                       ${
                         event?.eventUrl
                           ? `<p style="display: flex; flex-wrap: wrap;"><strong>Participant Link:</strong> <a class="ellipsis-link" href="${event?.eventUrl}" target="_blank" 
         rel="noopener noreferrer">${event?.eventUrl}</a></p>`
                           : ""
                       }
                       ${
                         event.eventTemplate === "AGM"
                           ? event?.galleryView?.galleryViewUrl
                             ? `<p style="display: flex; flex-wrap: wrap;"><strong>Gallery View Link:</strong> <a  href="${event?.galleryView?.galleryViewUrl}" target="_blank" 
        rel="noopener noreferrer">${event?.galleryView?.galleryViewUrl}</a></p>`
                             : ""
                           : ""
                       }
                     </td>
                   </tr>
                 </table>
               </td>
             </tr>
       
             <!-- Value Added Services & Reminders -->
             <tr>
               <td>
                 <table width="100%" style="background: #4CAF50; color: #fff; padding: 6px;">
                   <tr>
                     <td style="background: #4CAF50; color: white; font-family: Poppins; text-align: start; font-size: 16px; width: 50%;">
                       <strong>Value Added Services</strong>
                     </td>
                     <td style="background: #4CAF50; color: white; font-family: Poppins; text-align: start; font-size: 16px; width: 50%;">
                       <strong>Reminders</strong>
                     </td>
                   </tr>
                 </table>
                 <table width="100%" style="border: 1px solid #ddd; padding: 10px;">
                   <tr>
                     <td style="width: 300px; font-family: Poppins; vertical-align: top; padding: 8px;">
                     ${
                       event?.livePageSettings?.textQuestion
                         ? `<strong>Text Question: </strong>Yes<br>`
                         : ""
                     }
                       ${
                         event?.livePageSettings?.videoQuestion
                           ? `<strong>Video Question: </strong>Yes<br>`
                           : ""
                       }
                       
                       ${
                         event?.livePageSettings?.livePoll
                           ? `<strong>Live Polls: </strong>Yes<br>`
                           : ""
                       }
                       ${
                         event?.livePageSettings?.liveTickers
                           ? `<strong>Live Ticker: </strong>Yes<br>`
                           : ""
                       }
                       
                       ${
                         event?.livePageSettings?.playbackRequired
                           ? `<strong>Playback Info: </strong>Yes<br>`
                           : ""
                       }
                       <strong>Custom Microsite: </strong> ${
                         event?.advanceOptions?.micrositePrefix ? "Yes" : "No"
                       }
                       <p><strong>Social Media: </strong> MultiCall, YouTube, Facebook, Instagram, LinkedIn, Twitter</p>
                   </td>
       
                   <!-- Right Column (Reminders) -->
                   <td style="width: 300px; font-family: Poppins; vertical-align: top; padding: 8px;">
                       ${
                         event?.reminders?.sms
                           ? `<strong>SMS: </strong>Yes<br>`
                           : ""
                       }
                       ${
                         event?.reminders?.email
                           ? `<strong>Email: </strong>Yes<br>`
                           : ""
                       }
                       ${
                         event?.reminders?.whatsApp
                           ? `<strong>WhatsApp: </strong>Yes<br>`
                           : ""
                       }
                       
                       ${
                         event?.reminders?.voiceDrop
                           ? `<strong>Voice Drop: </strong>Yes<br>`
                           : `<strong>Voice Drop: </strong>No<br>`
                       }
                       ${
                         event?.reminders?.individual
                           ? `<strong>Personal Invitation: </strong>Yes<br>`
                           : `<strong>Personal Invitation: </strong>No<br>`
                       }
                   </td>
                   </tr>
                 </table>
               </td>
             </tr>
       
             <!-- Speaker Joining Information -->
             <tr>
               <td>
                 <table width="100%" style="background: #4CAF50; color: #fff; padding: 6px; text-align: center;">
                   <tr>
                     <td style="background: #4CAF50; color: white; font-family: Poppins; text-align: center; font-size: 16px; width: 50%;">
                       <strong>Speaker Joining Information</strong>
                     </td>
                   </tr>
                 </table>
                  <div style="display: grid; grid-template-columns: repeat(auto-fit, minmax(300px, 1fr)); gap: 10px; padding: 10px;">
                   ${speakersHTML}
                 </div>
               </td>
             </tr>
       
             <!-- Video Participant Joining Information -->
             <tr>
               <td>
                 <table width="100%" style="background: #4CAF50; color: #fff; padding: 6px; text-align: center;">
                   <tr>
                     <td style="background: #4CAF50; color: white; font-family: Poppins; text-align: center; font-size: 16px; width: 50%;">
                       <strong>Video Participant Joining Information</strong>
                     </td>
                   </tr>
                 </table>
                 <table width="100%" style="border: 1px solid #ddd; padding: 10px;">
                 </table>
               </td>
             </tr>
       
             <!-- Event Configuration -->
             <tr>
               <td>
                 <table width="100%" style="background: #4CAF50; color: #fff; padding: 6px; text-align: center;">
                   <tr>
                     <td style="background: #4CAF50; color: white; font-family: Poppins; text-align: center; font-size: 16px; width: 50%;">
                       <strong>Event Configuration</strong>
                     </td>
                   </tr>
                 </table>
                 <table width="100%" style="border: 1px solid #ddd; padding: 10px;">
                   <tr>
                     <td style="font-family: Poppins; width: 300px; padding: 10px;">
                     ${
                       event?.eventSettings?.enableRegistration
                         ? `<p><strong>Registrations: </strong> Yes</p>`
                         : ""
                     }
                        ${
                          event?.eventSettings?.commonPassword
                            ? `<p><strong>Common Password: </strong>Yes</p>`
                            : ""
                        }
                        ${
                          event?.eventSettings?.enableLogins
                            ? `<p><strong>Logins Required: </strong>Yes</p>`
                            : ""
                        }
                        ${
                          event?.eventSettings?.singleUserSingleEntry
                            ? `<p><strong>Single User Single Entry: </strong>Yes</p>`
                            : ""
                        }
                        ${
                          event?.eventSettings?.userViewInsidePage
                            ? `<p><strong>Users allowed to view inside Pages: </strong>Yes</p>`
                            : ""
                        }
                       ${
                         event?.speakerSection?.speakersRequired
                           ? `<p><strong>Speakers Section: </strong>Yes</p>`
                           : ""
                       }
                       <p><strong>Speakers Visibility: </strong>${
                         event?.speakerSection?.speakersVisibility
                           ? _.startCase(
                               event?.speakerSection?.speakersVisibility,
                             )
                           : ""
                       }</p>
                        ${
                          event?.forceReferrer?.forceReferrerCheck
                            ? `<p><strong>Force Referrer Check: </strong>Yes</p>`
                            : ""
                        }
                        ${
                          event?.livePageSettings?.safeHarborMsg
                            ? `<p><strong>Safe Harbor: </strong>Yes</p>`
                            : ""
                        }
                     </td>
                     <td style="font-family: Poppins; width: 300px; padding: 10px;">
                       ${
                         event?.eventSettings?.passwordRequired
                           ? `<p><strong>Password Required: </strong>Yes</p>`
                           : ""
                       }
                        ${
                          event?.eventSettings?.sendEmailDuringRegistration
                            ? `<p><strong>Send Emails During Registration: </strong>Yes</p>`
                            : ""
                        }
                       <p><strong>Pre-validate Registrations: </strong> ${
                         event?.preValidateUsers?.preValidateLabel
                           ? _.startCase(
                               event?.preValidateUsers?.preValidateLabel,
                             )
                           : ""
                       }</p>
                        ${
                          event?.resourceSection?.resourcesRequired
                            ? `<p><strong>Resources Section: </strong>Yes</p>`
                            : ""
                        }
                        ${
                          event?.eventSettings?.resourcesVisibility
                            ? `<p><strong>Resources Visibility: </strong>Yes</p>`
                            : ""
                        }
                        ${
                          event?.forceReferrer?.referrerCheckUrl
                            ? `<p><strong>Force Referrer URL: </strong>Yes</p>`
                            : ""
                        }
                       <p><strong>Content Format: </strong> ${
                         event?.livePageSettings?.contentFormat
                           ? _.startCase(event?.livePageSettings?.contentFormat)
                           : "-"
                       }</p>
                     </td>
                   </tr>
                 </table>
               </td>
             </tr>
       
             <!-- Operator Script -->
             <tr>
               <td>
                 <table width="100%" style="background: #4CAF50; color: #fff; padding: 6px; text-align: center;">
                   <tr>
                     <td style="background: #4CAF50; color: white; font-family: Poppins; text-align: center; font-size: 16px; width: 50%;">
                       <strong>Operator Script</strong>
                     </td>
                   </tr>
                 </table>
                 <table width="100%" style="border: 1px solid #ddd; padding: 10px;">
                   <tr>
                     <td style="font-family: Poppins;">
                       <p>Regards</p>
                       <p><strong>${event?.eventManageName}</strong></p>
                       <p><strong style="color: #00aeef ;">C3ware Multi</strong>
                         <strong style="color: #5CB338 ;">Call Technologies Pvt Ltd</strong>
                       </p>
                       <p><strong style="color: #00aeef ;">+91 44 66776600</strong>
                       <span>|</span>
                         <strong style="color: #5CB338 ;">+91 44 22540231</strong>
                       </p>
                       <p><strong style="color: #00aeef ;">events@multicall.in </strong>
                       <span>|</span>
                         <strong style="color: #5CB338 ;">customercare@dsnl.in</strong>
                       </p>
                        <img src=https://justact.s3.ap-south-1.amazonaws.com/Justact/1740660799066-ffa8d6e8-80b2-4bd4-a917-e3f6726cfe17/MulticallLogo.png alt="Left Image" width="174" height="60">
                     </td>
                   </tr>
                 </table>
               </td>
             </tr>
             </table>
             </div>
             `;
};
